import { careApiGet, careApiPost, normalizeListResponse } from './careApiClient';
import { mapBusinessQrRecord } from '../utils/businessQr';

/** PocketBase collection (spelling matches backend). */
export const BUSINESS_QRS_RECORDS_PATH = '/collections/bussiness_QRs/records';

export async function fetchBusinessQrsList(token, params) {
  const payload = await careApiGet(BUSINESS_QRS_RECORDS_PATH, { token, params });
  return normalizeListResponse(payload)
    .map(mapBusinessQrRecord)
    .sort(
      (a, b) =>
        new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime(),
    );
}

export async function createBusinessQrRecord(token, { name }) {
  const label = String(name ?? '').trim();
  if (!label) {
    throw new Error('Business name is required.');
  }
  const payload = await careApiPost(BUSINESS_QRS_RECORDS_PATH, {
    token,
    body: { name: label }
  });
  return mapBusinessQrRecord(payload);
}
